import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import Cookies from 'js-cookie'
import { storeMaker } from './../utils/index'
Vue.use(Vuex)

// const modulesFiles = require.context('./modules', true, /\.js$/)

// const modules = modulesFiles.keys().reduce((modules, modulePath) => {
//   const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
//   const value = modulesFiles(modulePath)
//   modules[moduleName] = value.default
//   return modules
// }, {})

const state = storeMaker({
  Authorization: '',
  userInfo: {}
})
const actions = {

}
const mutations = {
  SET_TOKEN (state, token, expires) {
    state.Authorization = token
    if (token) {
      Cookies.set('Authorization', token, {
        expires
      })
    } else {
      Cookies.remove('Authorization')
    }
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = Object.assign({}, userInfo)
  }
}
const store = new Vuex.Store({
  getters,
  // modules,
  actions,
  state,
  mutations,
  strict: true
})

export default store